<template>
  <div>
    <div>
      <div v-if="layoutType == 1">
        <el-radio
          v-model="backgroundImg.showType"
          label="1"
        >
          平铺
        </el-radio>
        <el-radio
          v-model="backgroundImg.showType"
          label="2"
        >
          拉伸
        </el-radio>
      </div>
      <div v-if="layoutType == 2">
        <el-radio
          v-for="(item, index) in layoutOptions"
          :key="index"
          v-model="backgroundImg.showType"
          :label="item.value"
        >
          {{ item.label }}
        </el-radio>
      </div>
      <div class="text">
        只支持.jpg\.png文件且不超过2M，建议尺寸：750x1334像素，尺寸不匹配时，图片将被压缩或拉伸以铺满画面
      </div>
    </div>
    <div class="margin_container">
      <SpOnlyPicSelect
        :image-url="backgroundImg.url"
        @selectImage="selectImageData"
      />
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpBackgroundImg',
  mixins: [mixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          showType: null,
          url: ''
        }
      }
    },
    layoutType: {
      type: Number,
      default: 0
    },
    layoutOptions: {
      type: Array,
      default: () => [
        {
          label: '',
          value: ''
        }
      ]
    }
  },
  data () {
    return {
      backgroundImg: {
        showType: null,
        url: '',
        layoutType: this.layoutType
      }
    }
  },
  created () {
    // let that = this
    // if(this.isQuote){
    //   this.backgroundImg = this.value
    //   this.$watch('backgroundImg', (nv) => {
    //     that.$emit('input', nv)
    //   }, {
    //     deep: true
    //   })
    // }
  },
  mounted () {},
  methods: {
    selectImageData (selectdata) {
      let msg_type = 'image'
      if (msg_type === 'image') {
        this.$set(this.backgroundImg,'url',selectdata)
        if(!this.showType) {
        this.$set(this.backgroundImg,'showType','full-width')
        }
      } else if (msg_type === 'link') {
        this.content.link.picurl = selectdata
      } else if (msg_type === 'miniprogram') {
        this.content.miniprogram.img_url = selectdata
      }
    }
  }
}
</script>
<style scoped lang="scss">
.margin_container {
  display: flex;
}

.text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #aaaaaa;
  margin: 16px 0;
}
</style>
